import { motion } from "framer-motion";

const logos = [
  { src: "/assets/clients/alex.png", alt: "Alex", size: "h-9 sm:h-10 lg:h-12" },
  { src: "/assets/clients/ashokalite.png", alt: "Ashokalite", size: "h-14 sm:h-16 lg:h-20" },
  { src: "/assets/clients/coin.png", alt: "Coin", size: "h-11 sm:h-12 lg:h-14" },
  { src: "/assets/clients/elleys.png", alt: "Elleys", size: "h-10 sm:h-11 lg:h-12" },
  { src: "/assets/clients/fybros.png", alt: "Fybros", size: "h-9 sm:h-10 lg:h-12" },
  { src: "/assets/clients/polycab.png", alt: "Polycab", size: "h-12 sm:h-14 lg:h-16" },
  { src: "/assets/clients/girish.png", alt: "Girish", size: "h-12 sm:h-14 lg:h-16" },
  { src: "/assets/clients/lavida.png", alt: "La Vida", size: "h-14 sm:h-16 lg:h-20" },
  { src: "/assets/clients/norwood.png", alt: "Norwood", size: "h-9 sm:h-10 lg:h-12" },
  { src: "/assets/clients/polex.png", alt: "Polex", size: "h-8 sm:h-9 lg:h-11" },
  { src: "/assets/clients/pritam.png", alt: "Pritam", size: "h-8 sm:h-9 lg:h-11" },
  { src: "/assets/clients/siemens.png", alt: "Siemens", size: "h-7 sm:h-8 lg:h-10" },
  { src: "/assets/clients/vankon.png", alt: "Vankon", size: "h-9 sm:h-10 lg:h-12" },
  { src: "/assets/clients/veto.png", alt: "Veto", size: "h-9 sm:h-10 lg:h-11" },
  { src: "/assets/clients/vihan.png", alt: "Vihan", size: "h-8 sm:h-9 lg:h-10" },
  { src: "/assets/clients/vinay.png", alt: "Vinay", size: "h-10 sm:h-11 lg:h-14" },
];

const cellReveal = {
  hidden: { opacity: 0, y: 24 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: 0.045 * i },
  }),
};

const NOISE =
  "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='120' height='120'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2'/%3E%3C/filter%3E%3Crect width='120' height='120' filter='url(%23n)' opacity='0.4'/%3E%3C/svg%3E\")";

export const Clientele = () => (
  <main data-testid="clientele-page" className="bg-paper text-ink">
    <section className="relative overflow-hidden">
      {/* subtle depth: faint centre shading + grain */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse 60% 45% at 50% 36%, rgba(10,10,10,0.035), transparent 70%)",
        }}
      />
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 opacity-[0.05]"
        style={{ backgroundImage: NOISE }}
      />

      <div className="relative mx-auto w-full max-w-[1400px] px-6 pb-20 pt-28 sm:px-10 lg:px-16 lg:pb-28 lg:pt-40">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between"
        >
          <div>
            <p className="mb-4 flex items-center gap-3 text-[11px] font-semibold uppercase tracking-[0.35em] text-brand" data-testid="clientele-eyebrow">
              <span className="inline-block h-2 w-2 bg-brand" />
              Company — Clientele
            </p>
            <h1 className="font-heading text-4xl font-black tracking-tighter sm:text-5xl lg:text-7xl" data-testid="clientele-heading">
              Trusted by leading brands.
            </h1>
            <span className="mt-6 block h-[2px] w-16 bg-brand" />
          </div>
          <p className="max-w-xs text-sm leading-relaxed text-ink/50 sm:text-base">
            A selection of the brands and businesses we work with.
          </p>
        </motion.div>

        <div
          className="mx-auto mt-16 grid max-w-6xl grid-cols-2 gap-px border border-ink/[0.08] bg-ink/[0.08] sm:grid-cols-3 lg:mt-24 lg:grid-cols-4"
          data-testid="clientele-grid"
        >
          {logos.map((logo, i) => (
            <motion.div
              key={logo.alt}
              custom={i}
              variants={cellReveal}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-40px" }}
              data-testid={`client-cell-${logo.alt.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="group relative flex h-32 items-center justify-center bg-paper sm:h-36 lg:h-44"
            >
              <span className="relative">
                <img
                  src={logo.src}
                  alt={logo.alt}
                  data-testid={`client-logo-${logo.alt.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                  className={`w-auto max-w-[82%] object-contain opacity-60 invert transition-opacity duration-500 ease-out group-hover:opacity-0 ${logo.size}`}
                />
                <span
                  aria-hidden
                  className="absolute inset-0 opacity-0 transition-opacity duration-500 ease-out group-hover:opacity-100"
                  style={{
                    backgroundColor: "#E8222D",
                    WebkitMaskImage: `url(${logo.src})`,
                    maskImage: `url(${logo.src})`,
                    WebkitMaskSize: "100% 100%",
                    maskSize: "100% 100%",
                  }}
                />
              </span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  </main>
);
